import { IWaterSubNetwork } from '../../interfaces/iwater-sub-network';
import { WaterNetwork } from '../water-network';

export class WaterSubNetworkBase {
  WaterSubNetworkId: number;
  MaximumCapacity: number;
  WaterNetworkId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  WaterNetwork?: WaterNetwork;

  constructor(item?: IWaterSubNetwork) {
    if (item) {
      this.WaterSubNetworkId = item.WaterSubNetworkId;
      this.MaximumCapacity = item.MaximumCapacity;
      this.WaterNetworkId = item.WaterNetworkId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.WaterNetwork = new WaterNetwork(item.WaterNetwork);

    }
  }
}